<template>
    <TransactionModal />
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"> <router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Financeiro</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Transações Financeiras</h4>
                    <div class="d-flex align-items-center gap-2 mt-1">
                        <span class="text-muted fs-7">Exibindo {{ transactions.length }} de {{ totalItems }}</span>

                        <span class="text-muted fs-7">|</span>
                        <div class="d-flex align-items-center gap-1">
                            <span class="text-muted fs-7">Mostrar:</span>
                            <select v-model="per_page" @change="changePerPage"
                                class="form-select form-select-sm border-0 bg-light text-muted fw-bold py-0"
                                style="width: 65px; height: 24px; font-size: 0.75rem; cursor: pointer;">
                                <option :value="15">15</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{ selectedIds.length }})
                            </button>
                        </div>
                    </transition>

                    <div class="btn-group me-2 shadow-sm" role="group">
                        <button type="button" class="btn btn-light border"
                            :class="{ 'bg-dark text-white border-dark fw-bold': quickFilter === 'day' }"
                            @click="setQuickFilter('day')">Hoje</button>
                        <button type="button" class="btn btn-light border"
                            :class="{ 'bg-dark text-white border-dark fw-bold': quickFilter === 'week' }"
                            @click="setQuickFilter('week')">Semana</button>
                        <button type="button" class="btn btn-light border"
                            :class="{ 'bg-dark text-white border-dark fw-bold': quickFilter === 'month' }"
                            @click="setQuickFilter('month')">Mês</button>
                        <button type="button" class="btn btn-light border"
                            :class="{ 'bg-dark text-white border-dark fw-bold': quickFilter === 'year' }"
                            @click="setQuickFilter('year')">Ano</button>
                    </div>
                    <div class="dropdown me-2 pe-3 border-end">
                        <button class="btn btn-pmg-light dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-printer me-1"></i> Opções de Relatórios
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow border-0 py-2 rounded-3">
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('pdf')">
                                    <i class="bi bi-file-earmark-pdf text-danger me-2"></i> Relatório Geral (PDF)
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('xlsx')">
                                    <i class="bi bi-file-earmark-excel text-success me-2"></i> Exportar Planilha (XLSX)
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openImportModal">
                                    <i class="bi bi-upload text-info me-2"></i> Importar Lançamentos
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter, 'border-primary text-primary fw-bold': quickFilter === 'custom' }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>
                    <div class="dropdown me-2">
                        <button class="btn btn-pmg-light dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-sort-down me-1"></i> Ordenar
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end shadow border-0 py-2 rounded-3"
                            style="min-width: 220px;">
                            <li>
                                <h6 class="dropdown-header fw-bold text-primary">Por Vencimento</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="changeSort('due_date', 'asc')"
                                    :class="{ 'bg-light fw-bold text-dark': sortBy === 'due_date' && sortDir === 'asc' }">
                                    <i class="bi bi-sort-down me-2"></i> Mais antigos primeiro
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="changeSort('due_date', 'desc')"
                                    :class="{ 'bg-light fw-bold text-dark': sortBy === 'due_date' && sortDir === 'desc' }">
                                    <i class="bi bi-sort-up me-2"></i> Mais recentes primeiro
                                </a>
                            </li>

                            <li>
                                <hr class="dropdown-divider">
                            </li>

                            <li>
                                <h6 class="dropdown-header fw-bold text-primary">Por Valor</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="changeSort('amount', 'desc')"
                                    :class="{ 'bg-light fw-bold text-dark': sortBy === 'amount' && sortDir === 'desc' }">
                                    <i class="bi bi-sort-numeric-down-alt me-2"></i> Maior valor
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="changeSort('amount', 'asc')"
                                    :class="{ 'bg-light fw-bold text-dark': sortBy === 'amount' && sortDir === 'asc' }">
                                    <i class="bi bi-sort-numeric-up me-2"></i> Menor valor
                                </a>
                            </li>

                            <li>
                                <hr class="dropdown-divider">
                            </li>

                            <li>
                                <h6 class="dropdown-header fw-bold text-primary">Por Data de Criação</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="changeSort('created_at', 'desc')"
                                    :class="{ 'bg-light fw-bold text-dark': sortBy === 'created_at' && sortDir === 'desc' }">
                                    <i class="bi bi-clock-history me-2"></i> Últimos adicionados
                                </a>
                            </li>
                        </ul>
                    </div>

                    <button class="btn btn-pmg-light" @click="refreshData" :disabled="loading" title="Atualizar tela">
                        <i class="bi bi-arrow-clockwise" :class="{ 'spin-animation': loading }"></i>
                    </button>


                    <button class="btn btn-pmg-primary" @click="openModal('create')">
                        <i class="bi bi-plus-lg me-1"></i> Novo
                    </button>
                </div>
            </div>

            <div class="row g-3 mb-4" v-if="summary">
                <div class="col-md-4">
                    <div class="card border-0 shadow-sm rounded-4 p-3 h-100" style="background-color: #f0fdf4;">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 class="text-success fw-bold mb-1">Total de Receitas</h6>
                                <h4 class="fw-bold text-success mb-0">R$ {{ formatCurrency(summary?.incomes || 0) }}
                                </h4>
                            </div>
                            <div class="bg-white p-2 rounded-3 shadow-sm">
                                <i class="bi bi-arrow-down-left text-success fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="card border-0 shadow-sm rounded-4 p-3 h-100" style="background-color: #fef2f2;">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 class="text-danger fw-bold mb-1">Total de Despesas</h6>
                                <h4 class="fw-bold text-danger mb-0">R$ {{ formatCurrency(summary?.expenses || 0) }}
                                </h4>
                            </div>
                            <div class="bg-white p-2 rounded-3 shadow-sm">
                                <i class="bi bi-arrow-up-right text-danger fs-4"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="card border-0 shadow-sm rounded-4 p-3 h-100"
                        :style="{ backgroundColor: (summary?.balance || 0) >= 0 ? '#f0f9ff' : '#fffbeb' }">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 class="fw-bold mb-1"
                                    :class="(summary?.balance || 0) >= 0 ? 'text-primary' : 'text-warning-emphasis'">
                                    Saldo do Período
                                </h6>
                                <h4 class="fw-bold mb-0"
                                    :class="(summary?.balance || 0) >= 0 ? 'text-primary' : 'text-warning-emphasis'">
                                    R$ {{ formatCurrency(summary?.balance || 0) }}
                                </h4>
                            </div>
                            <div class="bg-white p-2 rounded-3 shadow-sm">
                                <i class="bi bi-wallet2 fs-4"
                                    :class="(summary?.balance || 0) >= 0 ? 'text-primary' : 'text-warning-emphasis'"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3 align-items-end">
                        <div class="col-md-6">
                            <label class="form-label text-muted small fw-bold mb-1">Busca (Descrição ou Contato)</label>
                            <input v-model="filter.search" type="text" class="form-control form-control-pmg"
                                placeholder="Digite nome, CPF, descrição...">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Tipo</label>
                            <select v-model="filter.type" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option value="in">Receitas</option>
                                <option value="out">Despesas</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Status</label>
                            <select v-model="filter.status" class="form-select form-control-pmg">
                                <option value="">Todas</option>
                                <option value="pending">Pendente (Em aberto)</option>
                                <option value="partial">Parcialmente paga</option>
                                <option value="paid">Paga</option>
                                <option value="overdue">Atrasada</option>
                                <option value="canceled">Cancelada</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Empresa da Transação</label>
                            <select v-model="filter.branch_id" class="form-select form-control-pmg">
                                <option value="">Todas</option>
                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                    {{ branch.name || branch.trading_name }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Vencimento De</label>
                            <input v-model="filter.due_from" type="date" class="form-control form-control-pmg"
                                @change="quickFilter = 'custom'">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Vencimento Até</label>
                            <input v-model="filter.due_to" type="date" class="form-control form-control-pmg"
                                @change="quickFilter = 'custom'">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Criado De</label>
                            <input v-model="filter.created_from" type="date" class="form-control form-control-pmg"
                                @change="quickFilter = 'custom'">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Criado Até</label>
                            <input v-model="filter.created_to" type="date" class="form-control form-control-pmg"
                                @change="quickFilter = 'custom'">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Fracionamento</label>
                            <select v-model="filter.has_fractions" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option value="yes">Com Fracionamento</option>
                                <option value="no">Cota Única</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Centro de Custo</label>
                            <select v-model="filter.cost_center_id" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option v-for="cc in costCenters" :key="cc.id" :value="cc.id">{{ cc.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label text-muted small fw-bold mb-1">Itens Atrelados</label>
                            <select v-model="filter.has_items" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option value="yes">Com Produtos/Serviços</option>
                                <option value="no">Apenas Avulsas</option>
                            </select>
                        </div>
                        <div class="col-md-3 d-flex justify-content-start gap-2 mt-md-0 mt-3">

                        </div>
                        <div class="row mt-3">
                            <div class="col-md-4">
                                <button class="btn btn-dark btn-pmg-dark fw-bold py-2 px-4" @click="applyFilter"
                                    style="min-width: 150px;margin-right: 10px;">
                                    <i class="bi bi-search me-2"></i> Filtrar
                                </button>
                                <button class="btn btn-outline-danger py-2 px-3 ml-5" @click="clearFilter"
                                    title="Limpar Filtros">
                                    <i class="bi bi-x-lg"></i> Limpar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive" style="overflow: visible;">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 25%">Descrição</th>
                            <th style="width: 15%">Contato</th>
                            <th style="width: 15%">Vencimento</th>
                            <th style="width: 10%">Valor Total</th>
                            <th style="width: 15%">Tipo</th>
                            <th style="width: 10%">Gateway</th>
                            <th style="width: 12%">Status</th>
                            <th style="width: 8%" class="text-end">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="transactions.length > 0">
                        <tr v-for="item in transactions" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td>
                                <input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td>
                                <div class="fw-bold text-dark">{{ item.description }}</div>
                                <div class="d-flex gap-2 mt-1 flex-wrap" style="font-size: 0.72rem;">
                                    <span class="text-muted">Cat: {{ item.category?.name || 'N/D' }}</span>

                                    <span v-if="item.cost_center?.name" class="text-primary-emphasis fw-medium">
                                        <i class="bi bi-diagram-3-fill"></i> {{ item.cost_center.name }}
                                    </span>

                                    <!-- CÓDIGO NOVO: Exibição da Empresa -->
                                    <span v-if="item.branches && item.branches.length > 0" class="text-purple fw-medium"
                                        title="Empresa vinculada">
                                        <i class="bi bi-shop"></i> {{ item.branches[0].name ||
                                            item.branches[0].trading_name }}
                                    </span>
                                </div>

                                <div class="d-flex gap-1 mt-1 flex-wrap"
                                    v-if="(item.products && item.products.length > 0) || (item.services && item.services.length > 0)">

                                    <span v-if="item.products && item.products.length > 0"
                                        class="badge bg-success-subtle text-success border border-success-subtle fw-medium rounded-pill px-2 cursor-pointer item-badge-hover"
                                        style="font-size: 0.65rem;" title="Clique para ver os produtos"
                                        @click.stop="openItemsModal(item, 'products')">
                                        <i class="bi bi-box-seam me-1"></i> {{ item.products.length }} Produto(s)
                                    </span>

                                    <span v-if="item.services && item.services.length > 0"
                                        class="badge fw-medium rounded-pill px-2 cursor-pointer item-badge-hover"
                                        style="font-size: 0.65rem; background-color: #f5f3ff; color: #8b5cf6; border: 1px solid #ddd6fe;"
                                        title="Clique para ver os serviços"
                                        @click.stop="openItemsModal(item, 'services')">
                                        <i class="bi bi-tools me-1"></i> {{ item.services.length }} Serviço(s)
                                    </span>

                                </div>
                            </td>
                            <td class="fw-medium text-dark">
                                {{ item.transactionable?.name || 'Não Informado' }}
                                <div v-if="item.transactionable_type" class="small text-muted"
                                    style="font-size: 0.75rem;">
                                    {{ item.transactionable_type.includes('Client') ? 'Cliente' : 'Fornecedor' }}
                                </div>
                            </td>
                            <td>
                                <div class="text-dark">{{ formatDate(item.due_date) }}</div>
                                <div class="text-muted mt-1 d-flex align-items-center gap-1" style="font-size: 0.7rem;"
                                    title="Data em que o lançamento foi criado no sistema">
                                    <i class="bi bi-clock-history"></i>
                                    Criado: {{ formatDate(item.created_at) }}
                                </div>
                            </td>

                            <td class="fw-bold" :class="item.type === 'in' ? 'text-success' : 'text-danger'">
                                <div>{{ item.type === 'in' ? '+' : '-' }} R$ {{ formatCurrency(item.amount) }}</div>

                                <div v-if="item.allows_fractional || item.total_amortized > 0"
                                    class="small text-muted fw-normal mt-1"
                                    style="font-size: 0.7rem; line-height: 1.2;">

                                    <span class="text-success-emphasis">
                                        <i class="bi bi-check2-circle"></i> Pago: R$ {{ formatCurrency(item.amount_paid
                                            || 0) }}
                                    </span><br>

                                    <span v-if="(item.total_amortized || 0) - (item.amount_paid || 0) > 0"
                                        class="text-info-emphasis">
                                        <i class="bi bi-gift"></i> Bônus: R$ {{ formatCurrency((item.total_amortized ||
                                            0) - (item.amount_paid || 0)) }}<br>
                                    </span>

                                    <span class="text-danger-emphasis"
                                        v-if="(item.amount - (item.total_amortized || 0)) > 0">
                                        <i class="bi bi-clock-history"></i> Resta: R$ {{ formatCurrency(Math.max(0,
                                            item.amount - (item.total_amortized || 0))) }}
                                    </span>

                                    <span class="text-success-emphasis" v-else>
                                        <i class="bi bi-check-circle-fill"></i> Liquidado
                                    </span>

                                </div>
                            </td>

                            <td>
                                <span class="badge fw-medium px-2 py-1 border"
                                    :class="item.type === 'in' ? 'bg-success-subtle text-success border-success-subtle' : 'bg-danger-subtle text-danger border-danger-subtle'">
                                    <i class="bi"
                                        :class="item.type === 'in' ? 'bi-arrow-down-left' : 'bi-arrow-up-right'"></i>
                                    {{ item.type === 'in' ? 'Receita' : 'Despesa' }}
                                </span>
                            </td>
                            <td>
                                <span v-if="item.payment_gateway" class="badge fw-medium px-2 py-1 border"
                                    :class="getGatewayBadgeClass(item.payment_gateway.provider)">
                                    {{ formatGatewayName(item.payment_gateway.provider) }}
                                </span>
                                <span v-else class="badge bg-light text-secondary border px-2 py-1">
                                    Manual
                                </span>
                            </td>
                            <td>
                                <span class="badge rounded-pill px-3 py-2" :class="getStatusClass(item.status)">
                                    {{ getStatusLabel(item.status) }}
                                    <i v-if="item.external_reference" class="bi bi-cloud-check-fill text-primary ms-1"
                                        title="Cobrança vinculada ao Gateway"></i>
                                </span>
                                <div v-if="item.allows_fractional" class="mt-1">
                                    <span class="badge bg-light text-primary border border-primary-subtle opacity-75"
                                        style="font-size: 0.65rem;">
                                        <i class="bi bi-pie-chart-fill me-1"></i>Fracionável
                                    </span>
                                </div>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        aria-expanded="false" :disabled="item.status === 'canceled'">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0 p-2 rounded-3">

                                        <li v-if="item.payment_method === 'checkout' && item.payment_url">
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2 text-primary bg-primary-subtle"
                                                href="#"
                                                @click.prevent="copyToClipboard(item.payment_url, 'Link de pagamento copiado com sucesso!')">
                                                <i class="bi bi-link-45deg fs-5"></i>
                                                <span class="fw-bold">Copiar Link (Checkout)</span>
                                            </a>
                                        </li>

                                        <li v-if="item.gateway_metadata && item.gateway_metadata.invoice_url">
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2 text-primary bg-primary-subtle"
                                                :href="item.gateway_metadata.invoice_url" target="_blank">
                                                <i class="bi bi-box-arrow-up-right fs-5"></i>
                                                <span class="fw-bold">Abrir Fatura / Link</span>
                                            </a>
                                        </li>

                                        <li
                                            v-if="item.payment_method === 'pix' && item.gateway_metadata && item.gateway_metadata.pix_copy_paste">
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                                                href="#"
                                                @click.prevent="copyToClipboard(item.gateway_metadata.pix_copy_paste, 'Chave PIX copiada!')">
                                                <i class="bi bi-copy text-dark fs-5"></i>
                                                <span class="fw-medium">Copiar PIX</span>
                                            </a>
                                        </li>

                                        <li
                                            v-if="item.payment_method === 'boleto' && item.gateway_metadata && item.gateway_metadata.digitable_line">
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                                                href="#"
                                                @click.prevent="copyToClipboard(item.gateway_metadata.digitable_line, 'Código de barras copiado!')">
                                                <i class="bi bi-upc-scan text-dark fs-5"></i>
                                                <span class="fw-medium">Copiar Cód. Barras</span>
                                            </a>
                                        </li>

                                        <li
                                            v-if="(item.gateway_metadata) || (item.payment_method === 'checkout' && item.payment_url)">
                                            <hr class="dropdown-divider opacity-50">
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                                                href="#" @click.prevent="openModal('edit', item)">
                                                <i class="bi bi-eye text-muted fs-5"></i>
                                                <span class="fw-medium">Visualizar / Editar</span>
                                            </a>
                                        </li>
                                        <li
                                            v-if="item.allows_fractional || (item.charges && item.charges.length > 0) || (item.reward_logs && item.reward_logs.length > 0)">
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2"
                                                href="#" @click.prevent="openHistoryModal(item)">
                                                <i class="bi bi-clock-history text-primary fs-5"></i>
                                                <span class="fw-medium">Ver Histórico e Prêmios</span>
                                            </a>
                                        </li>
                                        <li>
                                            <button class="dropdown-item text-danger fw-medium"
                                                v-if="isCancellable(item)" @click="preparingForCancellation(item)">
                                                <i class="bi bi-x-circle me-2"></i> Cancelar Cobrança
                                            </button>
                                        </li>
                                        <li>
                                            <hr class="dropdown-divider opacity-50">
                                        </li>
                                        <li>
                                            <a class="dropdown-item rounded-2 d-flex align-items-center gap-2 py-2 text-danger"
                                                href="#" @click.prevent="confirmDelete(item, false)">
                                                <i class="bi bi-trash3 fs-5"></i>
                                                <span class="fw-medium">Excluir</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="8" class="text-center py-5 text-muted">
                                <i class="bi bi-wallet2 fs-1 mb-2 opacity-50"></i><br>
                                <span>Nenhum lançamento encontrado no período selecionado</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mt-4" v-if="hasMore">
                <button class="btn btn-pmg-light px-5 btn-sm fw-bold" @click="loadMore" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    {{ loading ? 'Carregando...' : 'Carregar mais itens' }}
                </button>
            </div>
        </div>



        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3"><i class="bi bi-exclamation-triangle-fill fs-1"></i></div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} lançamentos?` :
                            `Excluir este lançamento?` }}</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Não</button>
                        <button class="btn btn-danger px-4" @click="executeDeletion">Sim, Excluir</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalGeneralReport" tabindex="-1" aria-hidden="true" ref="modalGeneralReport">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <h5 class="fw-bold m-0 text-dark">Filtros do Relatório Financeiro</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body p-4">
                        <div class="row g-4">
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-2">Período De (Criação)</label>
                                <input type="date" class="form-control py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.created_from">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-2">Período Até (Criação)</label>
                                <input type="date" class="form-control py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.created_to">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-2">Período De (Vencimento)</label>
                                <input type="date" class="form-control py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.due_from">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-2">Período Até (Vencimento)</label>
                                <input type="date" class="form-control py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.due_to">
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Tipo de Lançamento</label>
                                <select class="form-select py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.type">
                                    <option value="ALL">Todas as Movimentações</option>
                                    <option value="in">Apenas Receitas</option>
                                    <option value="out">Apenas Despesas</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Status</label>
                                <select class="form-select py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.status">
                                    <option value="ALL">Todos os Status</option>
                                    <option value="paid">Efetivados (Pagos)</option>
                                    <option value="pending">A Receber / A Pagar</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-2">Empresa</label>
                                <select class="form-select py-2 rounded-3 text-secondary border"
                                    v-model="reportFilters.branch_id">
                                    <option value="">Todas as Empresas</option>
                                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                        {{ branch.name || branch.trading_name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <hr class="my-4 text-muted">

                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-bold text-dark m-0">Campos do Relatório (Mín. 2)</h6>
                            <div class="form-check form-switch m-0">
                                <input class="form-check-input cursor-pointer" type="checkbox" id="chk_selectAll"
                                    v-model="selectAllFields">
                                <label class="form-check-label small fw-bold cursor-pointer" for="chk_selectAll">
                                    Selecionar Todos
                                </label>
                            </div>
                        </div>

                        <div class="row g-2 mb-3">
                            <div class="col-md-4 col-sm-6" v-for="field in availableFields" :key="field.id">
                                <div class="form-check">
                                    <input class="form-check-input cursor-pointer" type="checkbox" :value="field.id"
                                        :id="'chk_' + field.id" v-model="reportFilters.fields">
                                    <label class="form-check-label small cursor-pointer" :for="'chk_' + field.id">
                                        {{ field.label }}
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="mt-5">
                            <button class="btn btn-pmg-primary w-100 py-3 fw-bold"
                                @click="exportFormat === 'pdf' ? generateGeneralReport() : exportExcelReport()"
                                :disabled="loadingReport || !isReportValid">
                                <template v-if="loadingReport">
                                    <span class="spinner-border spinner-border-sm me-2"></span> PROCESSANDO...
                                </template>
                                <template v-else>
                                    <i :class="exportFormat === 'pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-excel-fill'"
                                        class="me-2"></i>
                                    {{ exportFormat === 'pdf' ? 'GERAR RELATÓRIO PDF' : 'EXPORTAR PLANILHA XLSX' }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalImportPreview" tabindex="-1" aria-hidden="true" ref="modalImportPreview">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">
                            <i class="bi bi-file-earmark-arrow-up me-2 text-primary"></i>Pré-visualização da Importação
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="resetImport"></button>
                    </div>
                    <div class="modal-body p-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted small">Siga o padrão das colunas para evitar erros.</span>
                            <a href="#" @click.prevent="downloadImportTemplate"
                                class="btn btn-link btn-sm p-0 text-decoration-none">
                                <i class="bi bi-download me-1"></i> Baixar Planilha Exemplo
                            </a>
                        </div>
                        <div class="alert alert-warning border-0 shadow-sm mb-3" v-if="importDuplicates.length > 0">
                            <div class="d-flex align-items-center">
                                <i class="bi bi-layers-half fs-4 me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">Atenção: Possíveis Duplicidades</h6>
                                    <p class="small mb-0">
                                        Lançamentos com mesma Descrição, Valor e Data nas linhas:
                                        <strong>{{importDuplicates.map(d => d.linha).join(', ')}}</strong>. Eles serão
                                        importados, mas revise-os.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="alert alert-danger border-0 shadow-sm mb-3" v-if="importErrors.length > 0">
                            <div class="d-flex">
                                <i class="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">Erro: {{ importErrors.length }} linha(s) com dados
                                        inválidos</h6>
                                    <p class="small mb-0 text-secondary">
                                        Linhas com dados faltando: <strong>{{importErrors.map(e =>
                                            e.linha).join(',')}}</strong>.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="upload-area p-5 border-2 border-dashed rounded text-center bg-light"
                            v-if="!importPreviewData.length">
                            <input type="file" ref="fileInputImport" @change="handleFilePreview" class="d-none"
                                accept=".xlsx,.csv">
                            <i class="bi bi-file-earmark-excel fs-1 text-muted opacity-50"></i>
                            <p class="mt-3 mb-4">Selecione a planilha de lançamentos financeiros</p>
                            <button class="btn btn-pmg-primary" @click="$refs.fileInputImport.click()">Escolher
                                Arquivo</button>
                        </div>

                        <div v-else>
                            <div class="alert alert-info border-0 rounded-3 small">
                                <i class="bi bi-info-circle me-2"></i>
                                Encontramos <strong>{{ importPreviewData.length }}</strong> lançamentos.
                            </div>

                            <div class="table-responsive rounded-3 border">
                                <table class="table table-sm table-hover mb-0" style="min-width: 1000px;">
                                    <thead class="bg-light">
                                        <tr>
                                            <th class="small text-muted py-2 ps-3" style="width: 50px;">#</th>
                                            <th class="small text-muted py-2" style="width: 200px;">DESCRIÇÃO</th>
                                            <th class="small text-muted py-2" style="width: 140px;">DOCUMENTO</th>
                                            <th class="small text-muted py-2">CATEGORIA</th>
                                            <th class="small text-muted py-2 text-center" style="width: 90px;">TIPO</th>
                                            <th class="small text-muted py-2 text-center" style="width: 110px;">
                                                VENCIMENTO</th>
                                            <th class="small text-muted py-2 text-end" style="width: 110px;">VALOR</th>
                                            <th class="small text-muted py-2 text-center" style="width: 100px;">STATUS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in importPreviewData" :key="index"
                                            :class="{ 'table-danger-light': row.isInvalid }">
                                            <td class="ps-3 small text-muted">{{ row.excelRow }}</td>
                                            <td class="small fw-bold">
                                                <div class="text-truncate" style="max-width: 180px;"
                                                    :title="row.descricao">
                                                    <i v-if="row.isInvalid"
                                                        class="bi bi-exclamation-circle-fill text-danger me-1"
                                                        v-tooltip="row.errorsList" style="cursor: help;"></i>
                                                    {{ row.descricao }}
                                                </div>
                                            </td>
                                            <td class="small text-muted">{{ row.documento || '-' }}</td>
                                            <td class="small">{{ row.categoria }}</td>
                                            <td class="small text-center">
                                                <span class="badge"
                                                    :class="row.tipo.toLowerCase() === 'receita' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                                                    {{ row.tipo }}
                                                </span>
                                            </td>
                                            <td class="small text-center">{{ row.vencimento }}</td>
                                            <td class="small text-end fw-bold">R$ {{ row.valor }}</td>
                                            <td class="small text-center">
                                                <span class="badge bg-light text-dark border">{{ row.status }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer border-0 p-4 pt-0">
                        <button class="btn btn-pmg-light" data-bs-dismiss="modal" @click="resetImport">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4"
                            :disabled="!importPreviewData.length || loading || importErrors.length > 0"
                            @click="executeFinalImport">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                            Confirmar Importação
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalViewItems" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4 pb-2">
                    <h5 class="fw-bold m-0 d-flex align-items-center gap-2">
                        <i class="bi"
                            :class="viewingItemType === 'products' ? 'bi-box-seam text-success' : 'bi-tools text-purple'"></i>
                        {{ viewingItemType === 'products' ? 'Produtos Vinculados' : 'Serviços Vinculados' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body p-4 pt-2">
                    <p class="small text-muted mb-3">
                        Transação: <strong class="text-dark">{{ selectedTransactionForView?.description }}</strong>
                    </p>

                    <div class="table-responsive border rounded-3">
                        <table class="table table-sm table-hover mb-0 align-middle">
                            <thead class="bg-light">
                                <tr>
                                    <th class="small text-muted py-2 ps-3">Item</th>
                                    <th class="small text-muted py-2 text-center" style="width: 15%;">Qtd</th>
                                    <th class="small text-muted py-2 text-end" style="width: 25%;">V. Unit.</th>
                                    <th class="small text-muted py-2 text-end pe-3" style="width: 25%;">Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in viewingItemsList" :key="index">
                                    <td class="ps-3 small fw-bold text-dark">{{ item.description || 'Item sem nome' }}
                                    </td>
                                    <td class="small text-center">{{ item.pivot?.quantity || item.quantity || 1 }}</td>
                                    <td class="small text-end text-muted">
                                        R$ {{ formatCurrency(item.pivot?.unit_price || item.unit_price || item.price ||
                                            0)
                                        }}
                                    </td>
                                    <td class="small text-end fw-bold text-dark pe-3">
                                        R$ {{ formatCurrency((item.pivot?.quantity || item.quantity || 1) *
                                            (item.pivot?.unit_price || item.unit_price || item.price || 0)) }}
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot class="bg-light">
                                <tr>
                                    <td colspan="3" class="text-end small fw-bold py-2">Total dos Itens:</td>
                                    <td class="text-end small fw-bold pe-3 py-2"
                                        :class="viewingItemType === 'products' ? 'text-success' : 'text-purple'">
                                        R$ {{ formatCurrency(viewingItemsTotal) }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <div class="modal-footer border-0 p-4 pt-0">
                    <button type="button" class="btn btn-pmg-light w-100" data-bs-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalPaymentHistory" tabindex="-1" aria-hidden="true" ref="modalPaymentHistory">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content border-0 shadow-lg rounded-4">

                <div class="modal-header border-0 pt-4 px-4 pb-4 bg-primary text-white rounded-top-4"
                    style="background-color: #561569 !important;">
                    <div class="w-100">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="fw-bold m-0 d-flex align-items-center gap-2">
                                <i class="bi bi-clock-history"></i> Histórico da Cobrança
                            </h5>
                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>

                        <div class="row g-2 text-center" v-if="selectedTransactionHistory">
                            <div class="col-4">
                                <div class="bg-white bg-opacity-10 p-2 rounded-3">
                                    <div class="small opacity-75">Total da Fatura</div>
                                    <div class="fw-bold fs-5">R$ {{ formatCurrency(selectedTransactionHistory.amount) }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="bg-white bg-opacity-10 p-2 rounded-3">
                                    <div class="small opacity-75">Pago</div>
                                    <div class="fw-bold fs-5">R$ {{
                                        formatCurrency(selectedTransactionHistory.amount_paid ||
                                            selectedTransactionHistory.amount_paid) }}</div>
                                </div>
                            </div>
                           <div class="col-4">
                                <div class="bg-white bg-opacity-10 p-2 rounded-3">
                                    <div class="small opacity-75">Bonificação</div>
                                    <div class="fw-bold fs-5">
                                        <!-- Se houver dias ganhos nos logs, exibe o total de dias, senão exibe o desconto em dinheiro se houver -->
                                        {{ getTotalEarnedDays(selectedTransactionHistory) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-body p-4 pt-4 bg-light" v-if="selectedTransactionHistory">

                    <h6 class="fw-bold text-dark mb-3 d-flex align-items-center">
                        <i class="bi bi-wallet2 text-primary me-2"></i> Lançamentos Gerados
                    </h6>

                    <div v-if="selectedTransactionHistory.charges && selectedTransactionHistory.charges.length > 0">
                        <div v-for="charge in selectedTransactionHistory.charges" :key="'charge-' + charge.id"
                            class="card border-0 shadow-sm rounded-3 mb-2">
                            <div class="card-body p-3 d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center gap-3">
                                    <div class="bg-success-subtle p-2 rounded-circle d-flex align-items-center justify-content-center"
                                        style="width: 40px; height: 40px;">
                                        <i class="bi bi-cash-stack text-success fs-5"></i>
                                    </div>
                                    <div>
                                        <h6 class="fw-bold mb-0 text-dark">R$ {{ formatCurrency(charge.amount) }}</h6>
                                        <span class="small text-muted text-uppercase">{{
                                            formatChargeMethod(charge.method)
                                        }}</span>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <span class="badge rounded-pill mb-1" :class="getChargeStatusClass(charge.status)">
                                        <i class="bi bi-check-circle-fill me-1" v-if="charge.status === 'paid'"></i>
                                        {{ getChargeStatusLabel(charge.status) }}
                                    </span>
                                    <div class="small text-muted fw-medium" style="font-size: 0.7rem;">
                                        {{ formatDate(charge.paid_at || charge.created_at) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center py-3 text-muted small border rounded-3 bg-white mb-4">
                        Nenhum pagamento fracionado registrado.
                    </div>

                    <h6 class="fw-bold text-dark mb-3 mt-4 d-flex align-items-center">
                        <i class="bi bi-gift-fill text-warning me-2"></i> Bonificações Ganhas
                    </h6>

                    <div
                        v-if="selectedTransactionHistory.reward_logs && selectedTransactionHistory.reward_logs.length > 0">
                        <div v-for="log in selectedTransactionHistory.reward_logs" :key="'log-' + log.id"
                            class="card border-0 shadow-sm rounded-3 mb-2">
                            <div class="card-body p-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <div class="fw-bold text-dark" style="font-size: 0.9rem;">Referente ao pgto de R$ {{
                                        formatCurrency(log.amount_paid) }}</div>

                                    <div class="mt-1">
                                        <span v-if="log.reward_type === 'discount' || log.earned_discount_amount > 0"
                                            class="badge bg-success-subtle text-success border border-success-subtle px-2 py-1">
                                            <i class="bi bi-tag-fill me-1"></i> R$ {{
                                                formatCurrency(log.earned_discount_amount) }} OFF
                                        </span>

                                        <span v-if="log.reward_type === 'extension' || log.earned_extension_days > 0"
                                            class="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-2 py-1">
                                            <i class="bi bi-calendar-plus me-1"></i> + {{
                                                parseInt(log.earned_extension_days
                                                    || log.reward_value) }} Dias
                                        </span>
                                    </div>
                                </div>
                                <div class="text-end">
                                    <div class="small text-muted fw-medium" style="font-size: 0.75rem;">
                                        {{ formatDate(log.created_at) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center py-3 text-muted small border rounded-3 bg-white">
                        Nenhuma bonificação conquistada até o momento.
                    </div>

                </div>
                <div class="modal-footer border-0 p-3 bg-light rounded-bottom-4">
                    <button type="button" class="btn btn-pmg-light w-100 fw-bold" data-bs-dismiss="modal">Fechar
                        Histórico</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="confirmCanceclModel" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                <div class="modal-body">
                    <div class="text-warning mb-3">
                        <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                    </div>
                    <h5 class="fw-bold">Tem certeza?</h5>
                    <p class="text-muted small">
                        Deseja realmente cancelar esta cobrança no valor de <br>
                        <strong class="text-dark" v-if="transactionToCancel">
                            R$ {{ formatCurrency(transactionToCancel.amount) }}
                        </strong>?
                    </p>
                    <p class="text-danger small mb-0" style="font-size: 0.7rem;">
                        Esta ação não poderá ser desfeita e a cobrança será baixada no gateway.
                    </p>
                </div>
                <div class="d-flex gap-2 justify-content-center pb-2">
                    <button class="btn btn-light px-4" data-bs-dismiss="modal">Voltar</button>
                    <button class="btn btn-warning text-dark fw-bold px-4 rounded-3" @click="executeCancelTransaction"
                        :disabled="isCanceling">
                        <span v-if="isCanceling" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/services/api';
import * as XLSX from 'xlsx';
import { transactionModalState } from '@/utils/transactionModalState';
import TransactionModal from '@/components/financial/TransactionModal.vue'

export default {
    inject: ['globalLoading'],
    components: { TransactionModal },
    data() {
        return {
            transactions: [],
            categories: [],
            alerts: [],
            contactSearchQuery: '',
            contactSearchResults: [],
            showContactDropdown: false,
            contactDebounce: null,
            categorySearchQuery: '',
            showCategoryDropdown: false,
            quickFilter: 'year',
            summary: { incomes: 0, expenses: 0, balance: 0 },
            form: {
                id: null, type: 'in', description: '', amount: '', category_id: '',
                transactionable_type: 'App\\Models\\Client', transactionable_id: '',
                status: 'pending', competence_date: '', due_date: '', payment_date: '',
                barcode_or_pix: '', is_recurring: false, frequency: 'monthly', day_of_month: 1,
                payment_method: '', payment_gateway_id: null, generate_charge: false,
                allows_fractional: false, fractional_min_amount: '', amount_paid: 0, cost_center_id: null,
                reward_type: null, reward_percentage: null, apply_late_fees: false, fine_type: 'fixed',
                fine_value: 2.00, interest_percentage: 1.00, tolerance_days: 0, products: [], services: []
            },
            selectedIds: [],
            filter: { search: '', type: '', status: '', due_from: '', due_to: '', created_from: '', created_to: '', cost_center_id: '', branch_id: '', has_fractions: '', has_items: '' },
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            per_page: 15,
            loading: false,
            hasMore: false,
            showFilter: false,
            itemToDelete: null,
            isBulkDelete: false,
            isEditing: false,
            isViewing: false,

            reportModalInstance: null,
            loadingReport: false,
            exportFormat: 'pdf',
            reportFilters: {
                due_from: '',
                due_to: '',
                created_from: '',
                created_to: '',
                type: 'ALL',
                status: 'ALL',
                branch_id: '',
                fields: ['description', 'amount', 'due_date', 'type', 'status']
            },
            availableFields: [
                { id: 'description', label: 'Descrição do Lançamento' },
                { id: 'category', label: 'Categoria' },
                { id: 'contact', label: 'Contato (Cliente/Fornecedor)' },
                { id: 'branch', label: 'Empresa da Transação' },
                { id: 'due_date', label: 'Vencimento' },
                { id: 'created_at', label: 'Data criação' },
                { id: 'competence_date', label: 'Competência' },
                { id: 'payment_date', label: 'Data de Pagamento' },
                { id: 'amount', label: 'Valor (R$)' },
                { id: 'type', label: 'Tipo (Receita/Despesa)' },
                { id: 'status', label: 'Status' },
                { id: 'payment_method', label: 'Forma de Pagamento' }
            ],
            importPreviewData: [],
            importFileObject: null,
            modalImportInstance: null,
            importErrors: [],
            importDuplicates: [],
            paymentOptions: [],
            costCenters: [],
            costCenterSearchQuery: '',
            showCostCenterDropdown: false,
            showRewardExplanation: false,
            hasProducts: false,
            hasServices: false,
            availableProducts: [],
            availableServices: [],
            updateTotalWithItems: true,
            selectedTransactionForView: null,
            viewingItemType: 'products',
            viewItemsModalInstance: null,
            branches: [],
            selectedBranchId: null,
            selectedTransactionHistory: null,
            historyModalInstance: null,
            transactionToCancel: null,
            isCanceling: false,
            sortBy: 'due_date',
            sortDir: 'desc',

        }
    },
    computed: {
        isAllSelected() { return this.transactions.length > 0 && this.selectedIds.length === this.transactions.length; },

        isReportValid() { return this.reportFilters.fields.length >= 2; },
        selectAllFields: {
            get() { return this.reportFilters.fields.length === this.availableFields.length; },
            set(value) {
                if (value) this.reportFilters.fields = this.availableFields.map(f => f.id);
                else this.reportFilters.fields = [];
            }
        },
        availableGatewaysForMethod() {
            const method = this.form.payment_method;
            if (!method) return [];

            return this.paymentOptions.filter(gateway => {
                if (method === 'pix') return gateway.allows_pix;
                if (method === 'boleto') return gateway.allows_ticket;
                if (method === 'credit_card') return gateway.allows_credit_card;
                if (method === 'checkout') return gateway.allows_checkout;
                return false;
            });
        },

        viewingItemsList() {
            if (!this.selectedTransactionForView) return [];
            return this.viewingItemType === 'products'
                ? (this.selectedTransactionForView.products || [])
                : (this.selectedTransactionForView.services || []);
        },
        viewingItemsTotal() {
            return this.viewingItemsList.reduce((sum, item) => {
                const qty = item.pivot?.quantity || item.quantity || 1;
                const price = item.pivot?.unit_price || item.unit_price || item.price || 0;
                return sum + (qty * price);
            }, 0);
        },
    },
    mounted() {
        const reportModalInstance = document.getElementById('modalGeneralReport');
        const modalViewItemsEl = document.getElementById('modalViewItems');
        const modalHistoryEl = document.getElementById('modalPaymentHistory');
        const modalCancelTransaction = document.getElementById('confirmCanceclModel');
        if (reportModalInstance) this.reportModalInstance = new window.bootstrap.Modal(reportModalInstance);
        if (modalViewItemsEl) this.viewItemsModalInstance = new window.bootstrap.Modal(modalViewItemsEl);
        if (modalHistoryEl) this.historyModalInstance = new window.bootstrap.Modal(modalHistoryEl);
        if (modalCancelTransaction) this.modalCancelTransaction = new window.bootstrap.Modal(modalCancelTransaction);
        const savedSortBy = localStorage.getItem('rmr_tx_sort_by');
        const savedSortDir = localStorage.getItem('rmr_tx_sort_dir');
        if (savedSortBy) this.sortBy = savedSortBy;
        if (savedSortDir) this.sortDir = savedSortDir;
        this.setQuickFilter('year');
        this.fetchPaymentOptions();
        this.fetchDefaultLateFees();
        this.fetchBranches();
    },
    methods: {

        async fetchDefaultLateFees() {
            this.loadingSettings = true;
            try {
                const response = await api.get('/system-settings/late-fees');
                const settings = response.data.data;
                this.form.fine_type = settings.fine_type || 'percentage';
                this.form.fine_value = settings.fine_value || 0;
                this.form.interest_percentage = settings.interest_percentage || 0;
                this.form.tolerance_days = settings.tolerance_days || 0;

            } catch (error) {
                console.error("Erro ao carregar configurações de multa e juros:", error);
            } finally {
                this.loadingSettings = false;
            }
        },

        async fetchBranches() {
            try {
                const response = await api.get('/branches', { params: { no_paginate: true } });
                this.branches = response.data.data || response.data;
            } catch (error) {
                console.error("Erro ao carregar Empresas para o filtro", error);
            }
        },

        async fetchPaymentOptions() {
            try {
                const response = await api.get('/payment-gateways/options');
                this.paymentOptions = response.data;
            } catch (error) {
                console.error("Erro ao carregar opções de pagamento");
            }
        },
        formatDateForInput(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        selectCostCenter(costCenter) {
            this.form.cost_center_id = costCenter.id;
            this.costCenterSearchQuery = costCenter.code
                ? `[${costCenter.code}] ${costCenter.name}`
                : costCenter.name;

            this.showCostCenterDropdown = false;
        },

        hideCostCenterDropdown() {
            setTimeout(() => {
                this.showCostCenterDropdown = false;
                if (!this.form.cost_center_id) {
                    this.costCenterSearchQuery = '';
                }
            }, 150);
        },

        setQuickFilter(period) {
            this.quickFilter = period;
            const today = new Date();
            let from, to;

            if (period === 'day') {
                from = to = this.formatDateForInput(today);
            } else if (period === 'week') {
                const d1 = new Date();
                const d2 = new Date();
                const firstDay = d1.getDate() - d1.getDay();
                d1.setDate(firstDay);
                d2.setDate(firstDay + 6);
                from = this.formatDateForInput(d1);
                to = this.formatDateForInput(d2);
            } else if (period === 'month') {
                from = this.formatDateForInput(new Date(today.getFullYear(), today.getMonth(), 1));
                to = this.formatDateForInput(new Date(today.getFullYear(), today.getMonth() + 1, 0));
            } else if (period === 'year') {
                from = this.formatDateForInput(new Date(today.getFullYear(), 0, 1));
                to = this.formatDateForInput(new Date(today.getFullYear(), 11, 31));
            }

            if (period !== 'custom') {
                this.filter.due_from = from;
                this.filter.due_to = to;
                this.filter.created_from = from;
                this.filter.created_to = to;
                this.fetchTransactions(1, false);
            }
        },

        async fetchTransactions(page = 1, append = false) {
            this.globalLoading.show('Carregando financeiro...');
            this.loading = true;
            try {
                const per_page = this.per_page;
                // Injetando sort_by e sort_dir aqui!
                const response = await api.get('/transactions', {
                    params: {
                        page,
                        per_page,
                        sort_by: this.sortBy,
                        sort_dir: this.sortDir,
                        ...this.filter
                    }
                });

                const { data, meta, summary } = response.data;
                this.transactions = append ? [...this.transactions, ...data] : data;
                if (summary !== undefined) this.summary = summary;
                this.totalItems = meta.total;
                this.currentPage = meta.current_page;
                this.lastPage = meta.last_page;
                this.hasMore = this.currentPage < this.lastPage;
            } catch (e) {
                this.showAlert('Erro ao buscar lançamentos.', 'error');
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },



        typeTransaction(type) {
            this.contactSearchResults = [];
            if (type === 'in') {
                this.form.transactionable_type = 'App\\Models\\Client';
            } else {
                this.form.transactionable_type = 'App\\Models\\Supplier';
            }
        },

        onContactInput() {
            this.showContactDropdown = true;

            clearTimeout(this.contactDebounce);
            if (this.contactSearchQuery.length < 2) return;
            this.contactDebounce = setTimeout(async () => {

                const endpoint = this.form.transactionable_type.includes('Client') ? '/clients' : '/suppliers';
                const res = await api.get(endpoint, { params: { search: this.contactSearchQuery, limit: 8 } });
                this.contactSearchResults = res.data.data || res.data;

            }, 300);
        },
        selectContact(contact) {
            this.form.transactionable_id = contact.id;
            this.contactSearchQuery = contact.name;
            this.showContactDropdown = false;
        },
        hideContactDropdown() { setTimeout(() => this.showContactDropdown = false, 200); },
        selectCategory(category) {
            this.form.category_id = category.id;
            this.categorySearchQuery = category.name;
            this.showCategoryDropdown = false;
        },
        hideCategoryDropdown() { setTimeout(() => this.showCategoryDropdown = false, 200); },

        handleStatusChange() {
            if (this.form.status === 'paid' && !this.form.payment_date) this.form.payment_date = new Date().toISOString().split('T')[0];
            else if (this.form.status !== 'paid' && this.form.status !== 'partial') this.form.payment_date = '';
        },


        async saveTransaction() {
            this.loading = true;
            this.globalLoading.show('Processando transação...');
            try {
                await (this.isEditing
                    ? api.put(`/transactions/${this.form.id}`, this.form)
                    : api.post('/transactions', this.form));

                this.showAlert('Lançamento salvo com sucesso!');
                this.fetchTransactions();
                this.modalInstance.hide();
            } catch (e) {
                if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }
                    this.showAlert(mensagensErro, "error");
                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar lançamento.", "error");
                }
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) await api.post('/transactions/bulk-delete', { ids: this.selectedIds });
                else await api.delete(`/transactions/${this.itemToDelete.id}`);
                this.showAlert('Lançamento(s) removido(s)!');
                this.fetchTransactions();
                this.selectedIds = [];
            } catch (e) { this.showAlert('Erro ao excluir.', 'error'); }
            finally {
                const m = window.bootstrap.Modal.getInstance(document.getElementById('confirmDeleteModal'));
                if (m) m.hide();
            }
        },

        openModal(mode, item = null) {
            transactionModalState.open(item, () => {
                this.showAlert('Lançamento salvo com sucesso!');
                this.fetchTransactions(1, false);
            });
        },

        confirmDelete(target, bulk = false) {
            this.itemToDelete = target; this.isBulkDelete = bulk;
            new window.bootstrap.Modal(document.getElementById('confirmDeleteModal')).show();
        },

        formatCurrency(v) { return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 }); },
        formatDate(d) { return d ? new Date(d).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '-'; },

        getStatusLabel(s) {
            return {
                pending: 'Pendente',
                paid: 'Pago',
                overdue: 'Atrasado',
                canceled: 'Cancelado',
                partial: 'Parcial',
                extended: 'Em Prorrogação'
            }[s] || s;
        },

        getStatusClass(s) {
            return {
                pending: 'bg-warning-subtle text-warning',
                paid: 'bg-success-subtle text-success',
                overdue: 'bg-danger-subtle text-danger',
                canceled: 'bg-secondary-subtle text-secondary',
                partial: 'bg-info-subtle text-info border border-info-subtle',
                extended: 'bg-warning-subtle text-warning'
            }[s] || 'bg-light';
        },

        applyFilter() { this.fetchTransactions(1, false); },
        clearFilter() { this.filter = { search: '', type: '', status: '', due_from: '', due_to: '', created_from: '', created_to: '', cost_center_id: '', branch_id: '', has_fractions: '', has_items: '' }; this.setQuickFilter('month'); },
        loadMore() { if (this.hasMore) this.fetchTransactions(this.currentPage + 1, true); },
        toggleAll() { this.selectedIds = this.isAllSelected ? [] : this.transactions.map(t => t.id); },
        showAlert(message, type = 'success') {
            const id = Date.now();
            const themeClass = type === 'error' ? 'danger' : type;
            let icon = 'bi-check-circle-fill';
            if (themeClass === 'danger') icon = 'bi-x-circle-fill';
            if (type === 'warning') icon = 'bi-exclamation-triangle-fill';
            this.alerts.push({ id, message, type: themeClass, icon });
            setTimeout(() => this.removeAlert(id), themeClass === 'danger' ? 6000 : 4000);
        },
        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },

        async generatePDF(item) {
            try {
                this.showAlert('Gerando documento...', 'info');
                const response = await api.get(`/transactions/${item.id}/document`, { responseType: 'blob' });
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a'); link.href = url; link.setAttribute('download', `cobranca_${item.id}.pdf`);
                document.body.appendChild(link); link.click(); document.body.removeChild(link); window.URL.revokeObjectURL(url);
            } catch (error) { this.showAlert('Erro ao gerar o documento.', 'error'); }
        },

        openReportModal(format = 'pdf') {
            this.exportFormat = format;
            if (this.reportModalInstance) {
                this.reportModalInstance.show();
            } else {
                const reportEl = document.getElementById('modalGeneralReport');
                if (reportEl) {
                    this.reportModalInstance = new window.bootstrap.Modal(reportEl);
                    this.reportModalInstance.show();
                }
            }
        },

        async generateGeneralReport() {
            this.loadingReport = true;
            try {
                const filtersToSend = { ...this.reportFilters };
                filtersToSend.fields = filtersToSend.fields.join(',');

                const params = new URLSearchParams(filtersToSend).toString();
                const response = await api.get(`/transactions/report/cashflow?${params}`, { responseType: 'blob' });

                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `relatorio_financeiro_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.reportModalInstance.hide();
                this.showAlert('Relatório gerado com sucesso!', 'success');
            } catch (error) {
                this.showAlert('Erro ao gerar relatório PDF.', 'error');
            } finally {
                this.loadingReport = false;
            }
        },

        async exportExcelReport() {
            this.loadingReport = true;
            try {
                const filtersToSend = { ...this.reportFilters };
                filtersToSend.fields = filtersToSend.fields.join(',');

                const params = new URLSearchParams(filtersToSend).toString();
                const response = await api.get(`/transactions/export/excel?${params}`, { responseType: 'blob' });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `financeiro_${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.reportModalInstance.hide();
                this.showAlert('Planilha gerada com sucesso!', 'success');
            } catch (error) {
                this.showAlert('Erro ao exportar planilha.', 'error');
            } finally {
                this.loadingReport = false;
            }
        },

        formatCurrencyInput(value) {
            if (value === '' || value === null || value === undefined) return '';
            return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        handleCurrencyInput(event, field) {
            let input = event.target;
            let value = input.value.replace(/\D/g, "");
            if (value === "") { this.form[field] = ''; input.value = ''; return; }
            let numericValue = (parseInt(value, 10) / 100);
            input.value = numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            this.form[field] = numericValue;
        },

        openImportModal() {
            this.resetImport();
            if (!this.modalImportInstance) {
                this.modalImportInstance = new window.bootstrap.Modal(document.getElementById('modalImportPreview'));
            }
            this.modalImportInstance.show();
        },

        resetImport() {
            this.importPreviewData = [];
            this.importFileObject = null;
            this.importErrors = [];
            this.importDuplicates = [];
            if (this.$refs.fileInputImport) this.$refs.fileInputImport.value = '';
        },

        formatExcelDate(excelDate) {
            if (!excelDate) return '---';
            if (typeof excelDate === 'number') {
                const date = new Date(Math.round((excelDate - 25569) * 86400 * 1000));
                const day = String(date.getUTCDate()).padStart(2, '0');
                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                return `${day}/${month}/${date.getUTCFullYear()}`;
            }
            return excelDate;
        },

        handleFilePreview(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.importFileObject = file;
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawJson = XLSX.utils.sheet_to_json(worksheet);

                const duplicatesMap = new Map();
                const errors = [];
                const duplicates = [];

                const statusAceitos = ['pendente', 'pago', 'atrasado', 'cancelado'];
                const pagamentosAceitos = ['pix', 'boleto', 'cartao de credito', 'transferencia', 'dinheiro'];

                this.importPreviewData = rawJson.map((row, index) => {
                    const excelRow = index + 2;

                    const rowData = {
                        excelRow: excelRow,
                        descricao: row['Descrição'] || row['descricao'] || '---',
                        valor: row['Valor'] || row['valor'] || '',
                        tipo: row['Tipo'] || row['tipo'] || '---',
                        vencimento: this.formatExcelDate(row['Vencimento'] || row['vencimento']),
                        status: row['Status'] || row['status'] || 'Pendente',
                        categoria: row['Categoria'] || row['categoria'] || 'Geral',
                        pagamento: row['Forma de Pagamento'] || row['forma de pagamento'] || 'PIX',
                        documento: row['Documento'] || row['documento'] || ''
                    };

                    const rowErrors = [];

                    if (rowData.descricao === '---') rowErrors.push('Descrição vazia');
                    if (rowData.tipo === '---') rowErrors.push('Tipo vazio');
                    if (rowData.vencimento === '---') rowErrors.push('Vencimento vazio');

                    const valorStr = String(rowData.valor).trim();
                    if (valorStr === '') {
                        rowErrors.push('Valor vazio');
                    } else if (/[^\d.,-]/g.test(valorStr)) {
                        rowErrors.push('Valor contém letras/caracteres inválidos');
                    }

                    const statusLimpo = String(rowData.status).toLowerCase().trim();
                    if (!statusAceitos.includes(statusLimpo)) {
                        rowErrors.push(`Status '${rowData.status}' inválido`);
                    }

                    const pagLimpo = String(rowData.pagamento)
                        .toLowerCase()
                        .normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                        .trim();

                    if (!pagamentosAceitos.includes(pagLimpo)) {
                        rowErrors.push(`Forma de pgto '${rowData.pagamento}' inválida`);
                    }

                    const hash = `${rowData.descricao}-${rowData.valor}-${rowData.vencimento}`;
                    if (hash !== '------') {
                        if (duplicatesMap.has(hash)) duplicates.push({ linha: excelRow });
                        else duplicatesMap.set(hash, true);
                    }

                    if (rowErrors.length > 0) {
                        errors.push({ linha: excelRow, detalhes: rowErrors.join(' | ') });
                    }

                    rowData.isInvalid = rowErrors.length > 0;
                    rowData.errorsList = rowErrors.join('\n');

                    return rowData;
                });

                this.importErrors = errors;
                this.importDuplicates = duplicates;
            };
            reader.readAsArrayBuffer(file);
        },

        async executeFinalImport() {
            if (!this.importFileObject) return;

            this.loading = true;
            const fd = new FormData();
            fd.append('file', this.importFileObject);

            try {
                await api.post('/transactions/import', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                this.showAlert("Importação iniciada! Os lançamentos aparecerão em breve.");
                this.modalImportInstance.hide();
                setTimeout(() => this.fetchTransactions(1, false), 2000);
            } catch (e) {
                this.showAlert("Erro ao processar arquivo no servidor.", "error");
            } finally {
                this.loading = false;
            }
        },

        downloadImportTemplate() {
            const link = document.createElement('a');
            link.href = '/templates/modelo_importacao_financeiro.xlsx';
            link.setAttribute('download', 'modelo_importacao_financeiro.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        refreshData() {
            this.fetchTransactions(1, false);
        },

        changePerPage() {
            this.currentPage = 1;
            this.fetchTransactions(1, false);
        },

        async copyToClipboard(text, successMessage) {
            try {
                const fullUrl = new URL(text, window.location.origin).href;
                await navigator.clipboard.writeText(fullUrl);
                this.showAlert(successMessage, 'success');
            } catch (err) {
                console.error('Falha ao copiar: ', err);
                this.showAlert('Não foi possível copiar o texto.', 'warning');
            }
        },

        formatGatewayName(provider) {
            if (!provider) return 'N/D';
            const names = {
                'efi': 'Efí Pay',
                'starkbank': 'Stark Bank',
                'asaas': 'Asaas',
                'pagarme': 'Pagar.me',
                'stripe': 'Stripe'
            };
            return names[provider.toLowerCase()] || provider;
        },

        getGatewayBadgeClass(provider) {
            if (!provider) return 'bg-light text-secondary border-secondary';
            const colors = {
                'efi': 'bg-warning bg-opacity-10 text-warning-emphasis border border-warning',
                'starkbank': 'bg-dark bg-opacity-10 text-dark border border-dark',
                'asaas': 'bg-info bg-opacity-10 text-info-emphasis border border-info',
                'pagarme': 'bg-danger bg-opacity-10 text-danger border border-danger',
                'stripe': 'bg-primary bg-opacity-10 text-primary border border-primary'
            };
            return colors[provider.toLowerCase()] || 'bg-secondary-subtle text-secondary border-secondary-subtle';
        },

        filteredList(query, list) {
            if (!query) return list.slice(0, 50);
            const lowerQuery = query.toLowerCase();
            return list.filter(x => x.name && x.name.toLowerCase().includes(lowerQuery)).slice(0, 50);
        },


        openHistoryModal(transaction) {
            this.selectedTransactionHistory = transaction;
            if (this.historyModalInstance) {
                this.historyModalInstance.show();
            }
        },

        formatChargeMethod(method) {
            const methods = {
                'pix': 'PIX',
                'boleto': 'Boleto Bancário',
                'credit_card': 'Cartão de Crédito',
                'checkout': 'Checkout'
            };
            return methods[method] || method || 'Manual';
        },

        getChargeStatusLabel(status) {
            const statuses = {
                'paid': 'Confirmado',
                'pending': 'Aguardando',
                'failed': 'Falhou',
                'expired': 'Expirou',
                'refunded': 'Estornado'
            };
            return statuses[status] || status;
        },

        getChargeStatusClass(status) {
            const classes = {
                'paid': 'bg-success-subtle text-success border border-success-subtle',
                'pending': 'bg-warning-subtle text-warning-emphasis border border-warning-subtle',
                'failed': 'bg-danger-subtle text-danger border border-danger-subtle',
                'expired': 'bg-secondary-subtle text-secondary border border-secondary-subtle',
                'refunded': 'bg-info-subtle text-info border border-info-subtle'
            };
            return classes[status] || 'bg-light text-dark';
        },

        isCancellable(item) {
            if (item.status === 'canceled') {
                return false;
            }

            const unalterableMethods = ['boleto', 'pix'];
            const currentMethod = item.payment_method ? item.payment_method.toLowerCase() : '';

            // If the invoice is paid and the method is boleto or pix, it cannot be cancelled
            if (item.status === 'paid' && unalterableMethods.includes(currentMethod)) {
                return false;
            }

            return true;
        },

        preparingForCancellation(item) {
            this.transactionToCancel = item;
            this.modalCancelTransaction.show();
        },

        async executeCancelTransaction() {
            if (!this.transactionToCancel) return;
            this.isCanceling = true;
            try {
                const res = await api.post(`/transactions/${this.transactionToCancel.id}/cancel`);
                this.showAlert(res.data.message || 'Cobrança cancelada com sucesso!', 'success');
                this.modalCancelTransaction.hide();
                this.transactionToCancel = null;
                this.fetchTransactions(1, false);

            } catch (error) {
                // Se o Laravel barrar (ex: já estava paga em PIX), cai aqui
                const msg = error.response?.data?.message || 'Erro ao cancelar a cobrança.';
                this.showAlert(msg, 'danger');
                this.modalCancelTransaction.hide();
            } finally {
                this.isCanceling = false;
            }
        },
        changeSort(by, dir) {
            this.sortBy = by;
            this.sortDir = dir;

            // Salva a preferência no navegador do usuário
            localStorage.setItem('rmr_tx_sort_by', by);
            localStorage.setItem('rmr_tx_sort_dir', dir);

            // Recarrega a tabela do zero
            this.fetchTransactions(1, false);
        },
        openItemsModal(transaction, type) {
            // Define qual transação foi clicada para o HTML ler o nome dela
            this.selectedTransactionForView = transaction;

            // Define se estamos abrindo 'products' ou 'services'
            this.viewingItemType = type;

            // Abre o modal na tela usando a instância do Bootstrap já criada no mounted
            if (this.viewItemsModalInstance) {
                this.viewItemsModalInstance.show();
            }
        },

        getTotalEarnedDays(transaction) {
    if (!transaction || !transaction.reward_logs || transaction.reward_logs.length === 0) {
        return '0 Dias';
    }
    
    // Soma todos os dias ganhos nos logs de recompensa
    const totalDays = transaction.reward_logs.reduce((sum, log) => {
        return sum + parseInt(log.earned_extension_days || log.reward_value || 0);
    }, 0);

    if (totalDays > 0) {
        return `+${totalDays} Dias`;
    }

    // Caso seja bonificação em dinheiro (desconto)
    const totalDiscount = transaction.reward_logs.reduce((sum, log) => {
        return sum + parseFloat(log.earned_discount_amount || 0);
    }, 0);

    return `R$ ${this.formatCurrency(totalDiscount)}`;
}
    }
}
</script>

<style scoped>
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
    transition: all 0.2s;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

.autocomplete-dropdown {
    max-height: 280px;
    overflow-y: auto;
    scrollbar-width: thin;
    z-index: 1100;
}

.autocomplete-item {
    transition: background 0.2s;
    cursor: pointer;
}

.autocomplete-item:hover {
    background-color: #f8fafc;
}

.bg-primary-subtle {
    background-color: #e0f2fe !important;
}

.text-primary {
    color: #0369a1 !important;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s;
}

.slide-fade-enter-from {
    transform: translateX(50px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
    animation: shake 0.4s ease-in-out;
}

.bg-success-subtle {
    border-left: 5px solid #16a34a !important;
}

.text-success-emphasis {
    color: #15803d !important;
}

.text-danger-emphasis {
    color: #b91c1c !important;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.dropdown-menu {
    z-index: 1065 !important;
}

.table-responsive {
    overflow: visible !important;
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.cursor-pointer {
    cursor: pointer;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

.item-badge-hover {
    transition: all 0.2s ease;
}

.item-badge-hover:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    filter: brightness(0.95);
}

.text-purple {
    color: #8b5cf6 !important;
}
</style>